import { supabase } from "@/integrations/supabase/client";
import type { FioTokenAccount } from "./tokenHealth";

/** PostgreSQL "undefined_column": `token_saved_at` before its migration is applied. */
const UNDEFINED_COLUMN = "42703";

/**
 * The company's API-connected Fio accounts with what `tokenHealth` needs.
 * Works before and after migration 20261103170000 (`token_saved_at`, `sync_error_since`).
 */
export async function fetchTokenAccounts(orgId: string): Promise<FioTokenAccount[]> {
  const query = (columns: string) =>
    supabase
      .from("bank_accounts")
      .select(columns)
      .eq("organization_id", orgId)
      .not("api_token", "is", null)
      .neq("api_token", "display-only");

  const first = await query("id, name, sync_error, sync_error_since, token_saved_at");
  if (!first.error) return (first.data ?? []) as unknown as FioTokenAccount[];
  if (first.error.code !== UNDEFINED_COLUMN) throw first.error;

  const { data, error } = await query("id, name, sync_error");
  if (error) throw error;
  return (data ?? []) as unknown as FioTokenAccount[];
}
